import { PartnerPage } from "./../partner/partner";
import { BrainstormClearErrorsAction } from "./../../store/action/BrainstormActions";
import { IntermarketingPage } from "./../intermarketing/intermarketing";
import { TrainingPage } from "./../training/training";
import { Component } from "@angular/core";
import {
  NavController,
  ToastController,
  LoadingController,
  Loading,
} from "ionic-angular";
import { Store } from "@ngrx/store";

import { Subscription } from "rxjs";

import { AppStore } from "../../store/AppStore";
import { SurveyPage } from "../survey/survey";
import { BrainstormListPage } from "../brainstorm-list/brainstorm-list";
import { SurveyClearErrorsAction } from "../../store/action/SurveyActions";
import { TrainingClearErrorsAction } from "../../store/action/TrainingActions";
import {
  ClearNotificationsAction,
  ListNotificationsAction,
  ClearErrorsNotificationsAction,
} from "../../store/action/NotificationActions";
import { LoginPage } from "../login/login";
import { CronosProjectsPage } from "./../cronos-projects/cronos-projects";
import { EvaluationsPage } from "./../avalicorp/evaluations";

import { NotificationModel } from "../../model/NotificationModel";
import { LogoutAction } from "../../store/action/UserActions";
import { environment } from "../../environments/environment";
import { CronosClearErrorsAction } from "../../store/action/CronosActions";

declare var swRegistration: any;

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  public version: string = environment.VERSION;

  public userName = null;
  public userEmail: string = null;
  public organizationName = null;
  public clientId: number = null;
  public userId: number = null;
  public loader: Loading;

  public countNotification: number = 0;
  public countEducorp: number = 0;
  public countPesquisa: number = 0;
  public countCronos: number = 0;
  public countIntermarketing: number = 0;
  public countAvalicorp: number = 0;
  public notifications: Array<NotificationModel>;

  public showGaap: boolean;

  private isLoading: boolean;
  private loggingOff: boolean;
  private notificationsLoaded: boolean;
  private refresher: any = null;

  private userStateSubscription: Subscription;
  private notificationStateSubscription: Subscription;

  constructor(
    public navCtrl: NavController,
    private store: Store<AppStore>,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController
  ) {
    this.isLoading = false;
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "top",
    });
    toast.present();
  }

  ionViewDidLoad() {
    this.loggingOff = false;
    this.showGaap = false;
  }

  ionViewDidEnter() {
    this.notificationsLoaded = false;
    this.userStateSubscription = this.store
      .select("userState")
      .subscribe((userState) => {
        if (userState.expired == true && !this.loggingOff) {
          this.loggingOff = true;
          this.logoff();
        }
        if (userState.user != null) {
          this.clientId = userState.user.clienteId;
          this.userName = userState.user.nome;
          this.userEmail = userState.user.email;
          this.userId = userState.user.id;
          this.store.dispatch(
            new ListNotificationsAction({
              clientId: this.clientId,
              userId: this.userId,
            })
          );
          if (this.clientId == environment.clientIdGapp) {
            this.showGaap = true;
          }
        }
        if (userState.organization != null) {
          this.organizationName = userState.organization.nomeFantasia;
        }
      });
    this.notificationStateSubscription = this.store
      .select("notificationState")
      .subscribe((notificationState) => {
        if (notificationState.loading && !this.isLoading) {
          this.loader = this.loadingCtrl.create({
            content: "Aguarde...",
          });
          this.loader.present();
          this.isLoading = true;
        }
        if (!notificationState.loading && this.isLoading) {
          this.loader.dismiss();
          this.isLoading = false;
        }
        if (notificationState.error) {
          setTimeout(() => {
            if (this.refresher != null) {
              this.refresher.complete();
              this.refresher = null;
            }
            if (!this.loggingOff) {
              this.presentToast("Erro ao trazer as notificações");
            }
            this.store.dispatch(new ClearErrorsNotificationsAction());
          }, 200);
        }
        if (notificationState.data != null && !this.isLoading) {
          this.countNotification = notificationState.data.filter(
            (x) => x.status == 0 || x.status == 1
          ).length;
          this.countPesquisa = notificationState.data.filter(
            (x) => x.servicoNotificacao == 1 && (x.status == 0 || x.status == 1)
          ).length;
          this.countEducorp = notificationState.data.filter(
            (x) => x.servicoNotificacao == 2 && (x.status == 0 || x.status == 1)
          ).length;
          this.countIntermarketing = notificationState.data.filter(
            (x) => x.servicoNotificacao == 3 && (x.status == 0 || x.status == 1)
          ).length;
          this.countCronos = notificationState.data.filter(
            (x) => x.servicoNotificacao == 4 && (x.status == 0 || x.status == 1)
          ).length;
          this.countAvalicorp = notificationState.data.filter(
            (x) => x.servicoNotificacao == 5 && (x.status == 0 || x.status == 1)
          ).length;
          this.notifications = notificationState.data.filter(
            (x) => x.status == 0 || x.status == 1
          );
          this.notificationsLoaded = true;
          if (this.refresher != null) {
            this.refresher.complete();
            this.refresher = null;
          }
        }
        this.removeNotifications(notificationState.readData);
      });
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
  }

  removeNotifications(list: Array<NotificationModel>) {
    if (list != null && list.length > 0 && swRegistration != null) {
      swRegistration.getNotifications().then(function (notifications) {
        notifications.forEach((notificationObject) => {
          list.forEach((item) => {
            if (notificationObject.data == item.id.toString()) {
              notificationObject.close();
            }
          });
        });
      });
    }
  }

  refreshData(ref) {
    this.refresher = ref;
    this.notificationsLoaded = false;
    this.store.dispatch(
      new ListNotificationsAction({
        clientId: this.clientId,
        userId: this.userId,
      })
    );
  }

  ionViewWillLeave() {
    if (this.userStateSubscription != null)
      this.userStateSubscription.unsubscribe();
    if (this.notificationStateSubscription != null)
      this.notificationStateSubscription.unsubscribe();
  }

  logoff() {
    this.presentToast("Acesso expirado. Efetue login novamente. (5)");
    localStorage.removeItem("expirationDate");
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  openPage(id) {
    if (id === 1) {
      this.navCtrl.setRoot(TrainingPage);
    } else if (id === 2) {
      this.navCtrl.setRoot(SurveyPage);
    } else if (id === 3) {
      this.navCtrl.setRoot(CronosProjectsPage);
    } else if (id == 4) {
      this.navCtrl.setRoot(IntermarketingPage, { type: 1 });
    } else if (id === 5) {
      this.navCtrl.setRoot(BrainstormListPage);
    } else if (id === 6) {
      this.navCtrl.setRoot(PartnerPage, {
        partner: "gaap",
        email: this.userEmail,
      });
    } else if (id === 7) {
      this.navCtrl.setRoot(EvaluationsPage);
    }
  }

  showNotifications() {
    this.navCtrl.push(IntermarketingPage, { type: 2 });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts